import React from 'react';
import classNames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import classes from '../../select-pantones-popup.scss';
const PreviewImage = ({
  preview,
  variantColor,
  progressMessage
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    background: variantColor
  },
  className: classNames(classes.column, classes.previewColumn)
}, /*#__PURE__*/React.createElement(Image, {
  src: preview,
  style: {
    background: variantColor
  },
  wrapperClassName: classes.previewImageWrapper,
  className: classes.logo,
  alt: "preview"
}), progressMessage && /*#__PURE__*/React.createElement("div", {
  className: classes.cornerMessage
}, progressMessage));
export default PreviewImage;